// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.map-button {
    position: absolute; z-index: 9999;
    background: white;
    border-radius: 50px;
    width: 25px; height: 25px;
    padding: 5px;
  }
`, "",{"version":3,"sources":["webpack://./src/app/components/super-pro/super-pro.ts"],"names":[],"mappings":";AACA;IACI,kBAAkB,EAAE,aAAa;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,WAAW,EAAE,YAAY;IACzB,YAAY;EACd","sourcesContent":["\n.map-button {\n    position: absolute; z-index: 9999;\n    background: white;\n    border-radius: 50px;\n    width: 25px; height: 25px;\n    padding: 5px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
